import { Box, IconButton, styled, Typography } from "@mui/material"
import React, { useEffect } from "react";
import ApexCharts from 'apexcharts';
import { StatusDot } from "../../../../../Components/StyledComponent";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CartLoader from "../../../../../Helper/Loaders/CartLoader";
import Slider from "react-slick";



const SliderActionButton = styled(IconButton)(({ position, disabled }) => ({
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    left: position === "left" ? "-40px" : null,
    right: position === "right" ? "-40px" : null,
    top: '-5px',
    padding: '6px',
    background: '#F3F5F7 !important',
    "& .MuiSvgIcon-root": {
        color: disabled ? "#B2B2B2" : '#000000',
        fontSize: "10px",
        marginLeft: 'auto',
        fontWeight: 500,
    },

    "& .MuiIconButton-root.Mui-disabled": {
        background: '#F3F5F7 !important'
    },
    "&:hover": {
        backgroundColor: "#D5D7FF",
        "& .MuiSvgIcon-root": {
            color: "#4D44D8",
        },
    },
}));


function CarouselSlider({ disabled, position, onClick }) {
    return (
        <SliderActionButton
            disabled={disabled}
            position={position}
            onClick={onClick}
        >
            {position === "left" ? <ArrowBackIosNewIcon /> : <ArrowForwardIosIcon />}
        </SliderActionButton>
    );
}

const RenderChartLegend = ({ legendSeries, chartIDs, isLoading = false }) => {

    const [visibleSeries, setVisibleSeries] = React.useState(legendSeries.map(() => true));

    useEffect(() => {
        setVisibleSeries(legendSeries.map(() => true))
    }, [legendSeries])

    const toggleSeriesOnLegendClick = (index) => {
        const updatedVisibility = [...visibleSeries];
        updatedVisibility[index] = !updatedVisibility[index];
        setVisibleSeries(updatedVisibility);
        const seriesName = legendSeries[index].name;
        const action = updatedVisibility[index] ? 'showSeries' : 'hideSeries';
        chartIDs.forEach((cID) => {
            ApexCharts.exec(cID, action, seriesName);
            ApexCharts.exec(cID, action, `${seriesName} mix`);
        })
    };

    if (isLoading) {
        return (<Box sx={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', gap: 1.5, flexWrap: 'wrap' }}>
            <CartLoader />
        </Box>)
    }

    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: true,
        nextArrow: (
            <CarouselSlider position={"right"} disabled={false} />
        ),
        prevArrow: (
            <CarouselSlider position={"left"} disabled={false} />
        ),
    };


    return (
        <Box className="comparison-legend-view"
            sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
            <Box sx={{
                width: '100%',
                '& .slick-track' : {display: 'flex !important',  flexWrap: 'nowrap !important'},
                '& .slick-slide': { paddingRight: 2 },
            }}>
                <Slider {...settings}>
                    {legendSeries.map((s, i) => (
                        <Box
                            key={`${s.name}-${i}`}
                            onClick={() => toggleSeriesOnLegendClick(i)}
                            sx={{
                                cursor: 'pointer',
                                display: 'flex !important',
                                alignItems: 'center',
                                opacity: visibleSeries[i] ? 1 : 0.5
                            }}>
                            <StatusDot sx={{ marginRight: '8px' }} color={s.color} />
                            <Typography sx={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }} variant="fw400s12c3D4B5A">{s.name}</Typography>
                        </Box>
                    ))}
                </Slider>
            </Box>
        </Box>
    )
}

export default RenderChartLegend
